module.exports = __webpack_public_path__ + "static/media/icon_cancel.2465f67e.svg";